import axios from "axios";

const api = axios.create({
  baseURL: window.env.apiHost,
  withCredentials: true,
});

export default api;
